/**
 * table type
 */
export enum DATA_TABLE_TYPE_ENUM {
    COMMESSA = "commessa",
    AGGIUDICATARIO = "aggiudicatario",
    AGGIUDICATARIO_FILIERA = "aggiudicatario_filiera",
    DOCUMENTO = "documento",
    PERSONA = "persona",
    PERSONA_CRUD = "personaCrud",
    MEZZO = "mezzo",
    MEZZO_CRUD = "mezzoCrud",
    ESECUTORE = "esecutore",
    ESECUTORE_CRUD = "esecutoreCrud",
    RICHIESTA = "richiesta",
    RICHIESTA_TAB_ESECUTORI = "richiesta_in_tab_esecutori",
    ACCESSO_PROGRAMMATO = "accesso_programmato",
    ACCESSO_EFFETTUATO = "accesso_effettuato",
    CANTIERE = "cantiere",
    SCADENZARIO = "scadenzario",
    MEZZO_ACCESSI = "mezzo_accessi",
    PERSONA_ACCESSI = "persona_accessi",
    DOCUMENTO_FULL_TEXT = "documento_full_text",
    ATTIVITA_CANTIERE = "attivita_cantiere",
    ATTIVITA_COMMESSA = "attivita_commessa",
    ATTIVITA_SELECTED = "attivita_selected",
    COMMESSA_SAL = "commessa_sal",
    VARIAZIONE_ACCESSI = "variazione_accessi",
    DOCUMENTO_VARIAZIONE = "documento_variazione",
    VARIAZIONE_ACCESSI_ALERT = "variazione_accessi_alert",
    VARIAZIONE_RISPOSTE_ALERT = "variazione_risposte_alert",
    GRUPPO = "gruppo",
    UTENTE = "utente",
    UTENTI_REF = "utentiRef",
    LOG_ATTIVITA = "log_attivita",
    ALLEGATI = "allegati",
    DOCUMENTO_ESECUTORE = "documento_esecutore",
    COMMESSA_NO_COUNT = "commessa_no_count",
    UPLOADS_MEZZI = "uploads_mezzi",
    UPLOADS_PERSONE = "uploads_persone"
}

/**
 * content type
 */
export enum CONTENT_TYPE_ENUM {
    APPLICATION_JSON = "application/json",
    APPLICATION_X_WWW_FORM_URLENCODED = "application/x-www-form-urlencoded",
    TEXT_PLAIN = "text/plain",
    APPLICATION_OCTET_STREAM = "application/octet-stream"
}

export enum PAGE_ENUM {
    HOME = "home",
    CHANGE_PASSWORD = "change_password",
    FULL_TEXT_SEARCH = "full_text_research",
    UPLOAD = "upload",
    LOGOUT = "logout"
}

export enum CARICAMENTO_MASSIVO_ENUM {
    MEZZO = 0,
    PERSONA = 1
}

/**
 * user type
 */
export enum USER_TYPE_ENUM {
    AFFIDATARIO = "Affidatario",
    AGGIUDICATARIO = "Aggiudicatario",
    AMMINISTRATORE = "Amministratore",
    ESECUTORE = "Esecutore",
    PREFETTURA = "Prefettura",
    GVS = "GVS", //Ufficio Gare
    DL = "DL",//Direzione Lavori
    CSE = "CSE", //Coordinamento in Esecuzione
    REFERENTE = "Referente" //per validazione accessi al cantiere

}

/**
 * request type
 */
export enum REQUEST_TYPE_ENUM {
    CENSIMENTO = 1,
    GESTIONE_ESECUTORE = 2,
    INTEGRAZIONE_MEZZI = 3,
    INTEGRAZIONE_PERSONE = 4,
    VARIAZIONE_RICHIESTA_CA = 5,
    VARIAZIONE_RICHIESTA_CO = 6,
    DISTACCO = 8,
    CONTRATTO_COMMESSA = 9,
    CONTRATTO_CANTIERE = 10,
}

/**
 * contract type
 */
export enum CONTRACT_TYPE_ENUM {
    CENSIMENTO = 1
}

export enum REQUEST_STATE_NAME_ENUM {
    APPROVATO = "Approvato",
    IN_LAVORAZIONE = "In Lavorazione",
    BOZZA = "Bozza",
    NON_VALIDO = "Non valido"
}

export enum REQUEST_STATE_ENUM {
    APPROVATO = 3,
    IN_LAVORAZIONE = 2,
    BOZZA = 1,
    NON_VALIDO = 30
}

export enum SCADENZARIO_STATE_ENUM {
    SCADUTO = "Scaduto",
    IN_SCADENZA = "In scadenza",
    VALIDO = "Allegato in scadenza"
}

export enum DOCUMENTO_STATE_ENUM {
    NON_VALIDO = 4,
    VALIDO = 3,
    IN_LAVORAZIONE = 2,
    BOZZA = 1
}

export enum DOCUMENTO_VARIAZIONE_STATE_ENUM {
    IN_VARIAZIONE = 1,
    VARIAZIONE_IN_LAVORAZIONE = 2,
    APPROVATO = 3,
    VARIAZIONE_NON_APPROVATA = 4
}

export enum DOCUMENTO_STATE_NAME_ENUM {
    NON_VALIDO = "Non valido",
    VALIDO = "Valido",
    IN_LAVORAZIONE = "In lavorazione",
    BOZZA = "Bozza"
}

export enum DOCUMENTO_VARIAZIONE_STATE_NAME_ENUM {
    IN_VARIAZIONE = "In Variazione",
    VARIAZIONE_IN_LAVORAZIONE = "Variazione in Lavorazione",
    APPROVATO = "Approvato",
    VARIAZIONE_NON_APPROVATA = "Variazione non Approvata"
}



/**
 * enum to determine which form must be presented
 */
export enum REQUEST_TYPE_FOR_ENUM {
    COMMESSA = "CO",
    CANTIERE = "CA"
}

/**
 * enum to determine which form must be presented
 */
export enum REQUEST_TYPE_FOR_NAME_ENUM {
    COMMESSA = "COMMESSA",
    CANTIERE = "CANTIERE"
}

/**
 * enum for type input of documento modal
 */
export enum INPUT_TYPE_ENUM {
    TEXT = "text",
    CHECKBOX = "checkbox",
    DATE = "date",
    UPLOAD = "upload",
    LABEL_ESECUTORE = "labelEsecutore",
    LABEL_DESCRITTIVA = "labelDescrittiva",
    RADIOBUTTON = "radiobutton",
    TEXT_AREA = "textarea"
}


export enum FILE_TYPE_ENUM {
    PDF = ".pdf",
    JPG = ".jpg",
    JPEG = ".jpeg",
    PNG = ".png",
    XLS = ".xls",
    XLSX = ".xlsx",
    DOC = ".doc",
    DOCX = ".docx",
    PPT = ".ppt",
    PPTX = ".pptx",
    TXT = ".txt",
    ZIP = ".zip"
}

/**
 * OPERAZIONI
 */
export enum OPERAZIONI_ENUM {
    LOGIN = "Login",
    LOGOUT = "Logout",
    VALIDAZIONE = "Validazione",
    RIGETTO = "Rigetto",
    CARICA_FILE = "Carico File",
    CANCELLAZIONE = "Cancellazione"
}